import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../../services/intermediary/loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private readonly loadingService: LoadingService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const notLoading = req.headers.get('not-loading');
    const shouldShow = !notLoading || notLoading === 'false';
    const isJsonp = req.method === 'JSONP';

    if (shouldShow && !isJsonp) this.loadingService.busy();

    return next.handle(req).pipe(finalize(() => this.loadingService.idle()));
  }
}
